import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Label, Row } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import styles from './styles.css';
import AddFieldsTabs from './AddFieldsTabs';
import DefaultSchemeList from './DefaultSchemeList';
import CustomFieldsList from './CustomFieldsList';

const tabs = {
  defaultScheme: DefaultSchemeList,
  customFields: CustomFieldsList,
};

function FieldsBuilder({ fieldArrayName, parentFields }) {
  const [currentTab, setCurrentTab] = useState('defaultScheme');

  const TabComponent = tabs[currentTab];
  return (
    <>
      <Row>
        <Col xs={12}>
          <Label required>
            <FormattedMessage
              id="ui-plugin-inventory-templates.templateSection.fields.sectionFields.label"
              defaultMessage="Section Fields"
            />
          </Label>
        </Col>
      </Row>
      <div className={styles.sectionFieldsBuilder}>
        <AddFieldsTabs currentTab={currentTab} setCurrentTab={setCurrentTab} />
        <Row className={styles.sectionRow}>
          <Col xs={12} className={styles.sectionFieldsTabs}>
            <TabComponent
              fieldArrayName={fieldArrayName}
              parentFields={parentFields}
            />
          </Col>
        </Row>
      </div>
    </>
  );
}

FieldsBuilder.propTypes = {
  fieldArrayName: PropTypes.string,
  parentFields: PropTypes.object,
};

export default FieldsBuilder;
